import CrudCustom from '../../../libs/custom/CrudCustom';

let JenisBiayaService = new CrudCustom('/jenis-biayas');
export default JenisBiayaService;
